import { SavedFormEvent, PageLoadedEvent, ModalPopupMainPageEvent } from 'app/shared/models/app-events-types.model';

// ALL EVENTS MUST SPECIFY A TYPE FOR THE PAYLOAD object
abstract class AppEvent<T> {
    type: AppEventType;
    payload: T;
}
// LIST OF AVAILABLE APP EVENTS
export enum AppEventType {
    SavedFormEvent,
    PageLoadedEvent,
    ModalPopupMainPageEvent
}
// =============
// TO SUPPORT TYPE CHECKS, EACH EVENT SHOULD SPECIFY ITS PAYLOAD TYPE
// =============
export class SavedFormEventWrapper implements AppEvent<SavedFormEvent> {
    type = AppEventType.SavedFormEvent;
    constructor(public payload: SavedFormEvent) { }
}
export class PageLoadedEventWrapper implements AppEvent<PageLoadedEvent> {
    type = AppEventType.PageLoadedEvent;
    constructor(public payload: PageLoadedEvent) { }
}
export class ModalPopupMainPageEventWrapper implements AppEvent<ModalPopupMainPageEvent> {
    type = AppEventType.ModalPopupMainPageEvent;
    constructor(public payload: ModalPopupMainPageEvent) { }
}

// `CATCH ALL` TYPE FOR ALL APP EVENT TYPES
export type AppEvents =
    SavedFormEventWrapper |
    PageLoadedEventWrapper |
    ModalPopupMainPageEventWrapper
    //  | more...
    ;



// WEBPACK FOOTER //
// ./src/app/shared/models/app-events.model.ts